/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Analysis_Not_FoundInputs */

const en_document_analysis_not_found = /** @type {(inputs: Document_Analysis_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document analysis not found`)
};

const nl_document_analysis_not_found = /** @type {(inputs: Document_Analysis_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentanalyse niet gevonden`)
};

/**
* | output |
* | --- |
* | "Document analysis not found" |
*
* @param {Document_Analysis_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const document_analysis_not_found = /** @type {((inputs?: Document_Analysis_Not_FoundInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Analysis_Not_FoundInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_document_analysis_not_found(inputs)
	return en_document_analysis_not_found(inputs)
});